module.exports = __webpack_public_path__ + "assets/img/240204.23592560.svg";